import { useState } from "react";
import clsx from "clsx";
import DatePicker from "react-datepicker";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { formatDateDigits } from "@transfr-inc/dashboard-components/utils";

/**
 * DatePickerButton from @transfr-inc/dashboard-components, minus its
 * hardcoded `minDate = today` (it was built for future-only expiration
 * dates) — a comparison start is always in the past, so this mirror passes
 * the caller's min/max through instead. Markup and class names match the
 * original, so the package stylesheet (loaded globally via index.scss)
 * themes it identically. Fold back into the shared library once
 * DatePickerButton grows minDate/maxDate props.
 */
export function ImpactReportDatePickerButton({
  date,
  onDateSelected,
  minDate,
  maxDate,
}) {
  const [open, setOpen] = useState();

  const onDateButtonClick = () => {
    setOpen(!open);
  };

  const onChange = (dateSelected) => {
    onDateSelected(dateSelected);
    setOpen();
  };

  return (
    <div className="date-picker-container">
      <div className="date-button-container">
        <div className={"date-button"} onClick={() => onDateButtonClick()}>
          <FontAwesomeIcon
            className="date-icon"
            icon={["fa-light", "fa-calendar-days"]}
          ></FontAwesomeIcon>
          <span className={clsx("label", date && "selected")}>
            {date ? formatDateDigits(date) : "Select a date..."}
          </span>
          <FontAwesomeIcon
            className="right-icon"
            icon="fa-light fa-chevron-right"
            rotation={90}
          ></FontAwesomeIcon>
        </div>
      </div>
      {open && (
        <div className="calendar-container">
          <DatePicker
            selected={date}
            onChange={onChange}
            dateFormat={"LL/dd/yy"}
            minDate={minDate}
            maxDate={maxDate}
            inline
            fixedHeight
          />
        </div>
      )}
    </div>
  );
}
